require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./solutions-南京地震馆.json") })
        }
      }, "path---solutions-南京地震馆");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---solutions-南京地震馆!./.cache/json/solutions-南京地震馆.json
// module id = 476
// module chunks = 231608221292675